import axios from 'axios';

export default {
    methods: {
        async itemSolicitudIndex(d, ok, err) {
            try {
                let r = await axios.get('items/solicitud?page=' + d.page, {params: d});
                ok(r.data);
            } catch (e) {
                err(e);
            }
        },
        async itemSolicitudUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('items/solicitud/' + id, d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async itemSolicitudStore(d, ok, err) {
            try {
                let r = await axios.post('items/solicitud', d);
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async itemSolicitudDestroy(id, ok, err) {
            try {
                let r = await axios.delete('items/solicitud/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async itemSolicitudPermiso(ok, err) {
            try {
                let r = await axios.post('items/solicitud/permiso');
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async itemSolicitudConfirmar(id, ok, err) {
            try {
                let r = await axios.post('items/solicitud/confirmar', {id: id});
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/items_solicitud.js